import { OrderPendingInvoicingHistoryItem } from '../../services/OrderPendingInvoicingHistories/GetOrderPendingInvoicingHistoryList/GetOrderPendingInvoicingHistoryListOutput';

const separationGroupText: Record<string, string> = {
  grau: 'Grau',
  nao_grau: 'Não grau'
};

const deliveryTypeText: Record<string, string> = {
  expressa: 'Expressa',
  transportadora: 'Transportadora'
};

const channelText: Record<string, string> = {
  omni: 'Omni',
  ecommerce: 'E-commerce'
};

// explicações exibidas ao passar o mouse nos títulos da lista e do modal
export const hints = {
  situation: 'Situação. Ampulheta: pendente, o pedido ainda aguarda o registro ou a transmissão do faturamento. Check verde: finalizado, já saiu dessa pendência.',
  time: 'Tempo desde o pagamento. Para pedidos pendentes, conta até agora; para finalizados, até o momento em que saíram da pendência.',
  entries: 'Quantas vezes o pedido entrou na pendência de faturamento. Mais de 1 significa que ele saiu e voltou.',
  pendingSince: 'Quando o pedido entrou na pendência pela última vez.',
  endedAt: 'Quando o pedido saiu da pendência de faturamento.',
  state: 'Estado atual do pedido no Sislog.',
  reason: 'Motivo informado pelo Quatro Olhos na última consulta automática, feita periodicamente.'
};

const ShopifyAdminOrdersUrl = 'https://admin.shopify.com/store/cs-zerezes/orders';

export const getShopifyAdminOrderUrl = (shopifyId?: number | null) =>
  shopifyId ? `${ShopifyAdminOrdersUrl}/${shopifyId}` : '';

export const getSituationText = (item: OrderPendingInvoicingHistoryItem) =>
  item.isPending ? 'Pendente' : 'Finalizado';

// 95 => 1h 35min; 1500 => 1d 1h
export const formatMinutes = (minutes?: number | null) => {
  if (minutes === undefined || minutes === null) return '';
  if (minutes < 60) return `${minutes}min`;

  const days = Math.floor(minutes / 1440);
  const hours = Math.floor((minutes % 1440) / 60);
  if (days > 0) return hours > 0 ? `${days}d ${hours}h` : `${days}d`;

  const remainingMinutes = minutes % 60;
  return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}min` : `${hours}h`;
};

export const getSeparationText = (item: OrderPendingInvoicingHistoryItem) =>
  (item.separationGroup && separationGroupText[item.separationGroup]) || item.separationType || '';

export const getDeliveryText = (item: OrderPendingInvoicingHistoryItem) =>
  (item.deliveryType && deliveryTypeText[item.deliveryType]) || item.deliveryType || '';

export const getChannelText = (item: OrderPendingInvoicingHistoryItem) => {
  const channel = (item.channel && channelText[item.channel]) || item.channel || '';
  return item.isInfluencer ? `${channel} (influenciador)` : channel;
};

// o erro da última consulta não apaga o último motivo válido; os dois são mostrados
export const getReasonText = (item: OrderPendingInvoicingHistoryItem) => {
  const reason = item.alert?.message || '';
  if (!item.diagnosticError) return reason;
  return reason ? `${reason} (última consulta falhou)` : `Falha na consulta: ${item.diagnosticError}`;
};

export const formatBoolean = (value?: boolean | null) => {
  if (value === undefined || value === null) return '';
  return value ? 'Sim' : 'Não';
};
